import { Link } from 'react-router-dom';
import bandjerryLogo from '@/images/bandjerry_logo.svg';

export default function PublicFooter() {
  return (
    <footer className="relative z-0 -mt-[50px] bg-neutral-100 px-6 pb-10 pt-[calc(60px+50px)] md:-mt-[80px] md:px-10 md:pt-[calc(60px+80px)] [clip-path:polygon(0_50px,100%_0,100%_100%,0_100%)] md:[clip-path:polygon(0_80px,100%_0,100%_100%,0_100%)]">
      <div className="mx-auto flex max-w-[1100px] flex-col items-start justify-between gap-10 lg:flex-row">
        {/* Brand */}
        <div className="max-w-[500px]">
          <Link to="/" className="mb-2 flex items-center gap-2 text-[28px] font-bold text-white no-underline">
            <img src={bandjerryLogo} alt="BandJerry logo" className="h-[1.5em] w-auto" />
            <span>BAND<span className="text-primary-600">JERRY</span></span>
          </Link>
          <p className="text-lg leading-relaxed text-white">
            Curated marketing moves for independent bands and musicians. Real-world strategy, not generic advice.
          </p>

          {/* Social Links */}
          <div className="mt-4 flex gap-2.5">
            {/* TikTok */}
            <a
              href="https://www.tiktok.com/@bandjerry.com"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-neutral-300 transition-colors hover:bg-neutral-400"
              aria-label="TikTok"
            >
              <svg className="h-[18px] w-[18px] fill-white" viewBox="0 0 24 24">
                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.88 2.89 2.89 0 01-2.88-2.88 2.89 2.89 0 012.88-2.88c.28 0 .56.04.82.11V9.4a6.33 6.33 0 00-.82-.05A6.34 6.34 0 003.15 15.7a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V9.41a8.16 8.16 0 004.76 1.52v-3.4a4.85 4.85 0 01-1-.84z" />
              </svg>
            </a>
            {/* Instagram */}
            <a
              href="https://www.instagram.com/bandjerry/"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-neutral-300 transition-colors hover:bg-neutral-400"
              aria-label="Instagram"
            >
              <svg className="h-[18px] w-[18px] fill-white" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
              </svg>
            </a>
            {/* YouTube */}
            <a
              href="https://www.youtube.com/@bandjerry-0"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-neutral-300 transition-colors hover:bg-neutral-400"
              aria-label="YouTube"
            >
              <svg className="h-[18px] w-[18px] fill-white" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
            {/* X (Twitter) */}
            <a
              href="https://x.com/_bandjerry_"
              className="flex h-9 w-9 items-center justify-center rounded-md bg-neutral-300 transition-colors hover:bg-neutral-400"
              aria-label="X"
            >
              <svg className="h-[18px] w-[18px] fill-white" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Footer Columns */}
        <div className="flex flex-col gap-8 sm:flex-row sm:gap-16 md:gap-20">
          <div>
            <h4 className="mb-4 text-base font-bold uppercase tracking-wider text-white">
              Product
            </h4>
            <ul className="list-none space-y-2 pl-0">
              <li><a href="#" className="text-base text-primary-600 no-underline transition-colors hover:text-primary-700">Features</a></li>
              <li><a href="/#cost" className="text-base text-primary-600 no-underline transition-colors hover:text-primary-700">Pricing</a></li>
              <li><Link to="/tutorials" className="text-base text-primary-600 no-underline transition-colors hover:text-primary-700">Tutorials</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 text-base font-bold uppercase tracking-wider text-white">
              Company
            </h4>
            <ul className="list-none space-y-2 pl-0">
              <li><Link to="/about" className="text-base text-primary-600 no-underline transition-colors hover:text-primary-700">About</Link></li>
              <li><Link to="/blog" className="text-base text-primary-600 no-underline transition-colors hover:text-primary-700">Blog</Link></li>
              <li><a href="mailto:hello@bandjerry.com" className="text-base text-primary-600 no-underline transition-colors hover:text-primary-700">Contact</a></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 text-base font-bold uppercase tracking-wider text-white">
              Legal
            </h4>
            <ul className="list-none space-y-2 pl-0">
              <li><Link to="/privacy-policy" className="text-base text-primary-600 no-underline transition-colors hover:text-primary-700">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-base text-primary-600 no-underline transition-colors hover:text-primary-700">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="mx-auto mt-10 max-w-[1100px] border-t border-neutral-300 pt-6">
        <p className="text-sm text-neutral-500">
          © {new Date().getFullYear()} BandJerry. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
